module.exports = __webpack_public_path__ + "img/Government_Bond_057187.0217ad81.png";